import "../styles/authStyles.css";

function AuthCard({ children, title }) {
  return (
    <div className=" auth-container m-auto mt-5 shadow-lg  p-4 shadow p-3 mb-5 bg-body-tertiary rounded ">
      <div className="d-flex pb-4 text-items-center">
        <h3 className="m-auto"> {title}</h3>
      </div>
      {children}
    </div>
  );
}

export default AuthCard;
